import React, { useEffect } from "react";
import { CorperateEmailSettingFormStyled } from "./styled";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { MdAdd, MdDelete } from "react-icons/md";
import { Buttons, Inputs } from "components";

// กลุ่มผู้รับอีเมลตาม event ของ Product Set (event_type ใน booking-email-config)
export const CORPERATE_EMAIL_GROUPS = [
  {
    key: "approver_email_list",
    event_type: "5",
    label: "1.ส่งอีเมลเตือนผู้มีอำนาจในการยืนยันให้เข้ามา Approve",
  },
  {
    key: "approved_email_list",
    event_type: "6",
    label: "2.ส่งอีเมลเตือนเจ้าหน้าที่เมื่อมีการ Approved เรียบร้อยแล้ว",
  },
];

const emailListSchema = yup.array().of(
  yup.object().shape({
    email: yup
      .string()
      .email("Email format is invalid")
      .required("Email is required"),
  })
);

const EmailGroup = ({ control, errors, name, label, disabled }) => {
  const { fields, append, remove } = useFieldArray({ control, name });
  return (
    <div className="group_wrap">
      <div className="group_label">{label}</div>
      {fields.map((item, index) => (
        <div key={item.id} className="email_row">
          <div className="er_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.TextField
                  {...field}
                  disabled={disabled}
                  errors={
                    errors[name] && errors[name][index]?.email?.message
                  }
                />
              )}
              name={`${name}.${index}.email`}
              defaultValue=""
            />
          </div>
          {!disabled && (
            <div className="btn_delete" onClick={() => remove(index)}>
              <MdDelete fontSize={25} color="red" />
            </div>
          )}
        </div>
      ))}
      {!disabled && (
        <div className="w130">
          <Buttons.BgIconPrefix
            label="Add Email"
            icon={<MdAdd size={18} />}
            onClick={() => append({ email: "" })}
          />
        </div>
      )}
    </div>
  );
};

const CorperateEmailSettingForm = ({
  initialValues,
  permission,
  onCancel,
  onSubmit,
}) => {
  const schema = yup.object().shape(
    CORPERATE_EMAIL_GROUPS.reduce((result, e) => {
      result[e.key] = emailListSchema;
      return result;
    }, {})
  );

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialValues) {
      reset({ ...initialValues });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const isDisabled = !(permission && permission.is_update);

  return (
    <CorperateEmailSettingFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form_title">การส่ง Email แจ้งเตือน</div>
        {CORPERATE_EMAIL_GROUPS.map((e) => (
          <EmailGroup
            key={e.key}
            control={control}
            errors={errors}
            name={e.key}
            label={e.label}
            disabled={isDisabled}
          />
        ))}
        <div className="action_row">
          <div className="w130">
            <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
          </div>
          {!isDisabled && (
            <div className="w130">
              <Buttons.BgStandard type="submit" label="Save" />
            </div>
          )}
        </div>
      </form>
    </CorperateEmailSettingFormStyled>
  );
};

CorperateEmailSettingForm.propTypes = {};

export default CorperateEmailSettingForm;
